
angular
.module('index')

	// Map view controller
	.controller('EventListController', function($translate, Classes, ApiRootUrl, MetaService, EventService, $timeout) {

        var self = this;
		self.surveyList = [];
		self.venueList = [];
		self.event_group_list = [];
		self.surveyListLoaded = false;
		
		self.searchTitleQuery = '';
		self.searchCityQuery = [];
		
        this.ApiRootUrl = ApiRootUrl;

		this.getSurveyList = function(){
			Classes.Event.get_list({
				'title_filter': self.searchTitleQuery,
				'city_filter': self.searchCityQuery.length ? self.searchCityQuery : null
			})
			.then(function(response){
				console.log(response);
				var list = response.event_list;
				//console.log(response);
				self.event_group_list = response.event_group_list;
				//console.log(self.event_group_list);
				angular.forEach(list, function(event, key) {
					self.setEventGroupDict(event);
				});				
				self.surveyList = list;
				console.log(list);
				
				$timeout(function(){
					self.setEqualBoxHeight();
				});
				
				return list;
			}).catch(function(e){
				console.log(e);
			});
		}
		self.getSurveyList();
		MetaService.setMetaKeywords()
		MetaService.setMetaDescription()
		MetaService.setTitle()
		MetaService.setContact()
		MetaService.setVenues()
		
		this.getVenueList = function(){
			//Classes.Venue.get_list_by_city()
			Classes.Venue.get_city_list()
			.then(function(list){
				//self.venueList = list;
				self.cityList = list;
				return list;
			}).catch(function(e){
				console.log(e);
			});
		}
		self.getVenueList();
		
		this.checkEventGroupAvailable = function(group){
			
			var now = new Date();
			var start = new Date(group.registration_start);
			var end = new Date(group.registration_end);

			now = now.getTime();
			start = start.getTime();
			end = end.getTime();
			
			if(now < start || now > end )
				return 'is_out_of_time';
			
			if (group.is_blocked || group.is_hidden)
				return 'is_blocked';
			
			return 'is_available';
		}
		
		this.setEqualBoxHeight = function(){
			
			var maxHeight = 0;
			var items = $('.events-list-item');
			
			items.each(function(key){
				if($(this).outerHeight() > maxHeight)
					maxHeight = $(this).outerHeight();
			});
			items.css({
				'height': maxHeight
			});
		}
		
		this.clearFilters = function(){
			self.searchTitleQuery = '';
			self.searchCityQuery = [];		
		}
		
		this.eventDefaultGroups = {};
		this.setEventGroupDict = function(event){
			var activeGroupsCount = 0;
			var eventDefaultGroup = null;
			event.event_groups_dict = [];
			angular.forEach(self.event_group_list, function(group, key) {

				if(group.event_id == event.id) {
					
				var item = {event_id: event.__id, group_id: group.id}
				
				if(group.online)
					var venue_city = 'Online';
				else if(group.venue_city)
					var venue_city = group.venue_city;
				else
					var venue_city = 'Nieokreślone miasto';
				
				//item.label = group.event_full_date + ' - ' + venue_city;
				item.label = group.event_start + ' - ' + venue_city;

				var group_state = self.checkEventGroupAvailable(group);
				if(group_state == 'is_blocked'){
					item.label += ' (' + $translate.instant('There are no vacancies') + ')';
					item.disabled = true;
				}else if(group_state == 'is_out_of_time'){
					// item.label += ' (' + $translate.instant('Registration completed') + ')';
					// item.disabled = true;
					return false;
				}
				
				if(!item.disabled)
					activeGroupsCount++;
				
				if(!item.disabled && !eventDefaultGroup)
					eventDefaultGroup = item;
				
				event.event_groups_dict.push(item);
			}
			});
			if(event.display_alt_location_form){
				event.event_groups_dict.push({
					event_id: event.__id,
					group_id: 'custom',
					label: event.alt_location_form_prompt 
				});
			}
			if(activeGroupsCount == 1){
				//self.eventDefaultGroups[event.__id] = event.event_groups_dict[0];
				self.eventDefaultGroups[event.__id] = eventDefaultGroup;
				EventService.setEventDefaultGroup(self.eventDefaultGroups);
			}
			return event;
		}
		
		this.onGroupChange = function(item){
			EventService.setEventDefaultGroup(self.eventDefaultGroups);
		};

        window.Classes = Classes;
        window.$ctrl = this;

    });